import {createAction, props} from "@ngrx/store";
import {
  CreateUserCommand,
  InviteUserCommand,
  UpdateUserCommand,
  UserDto,
  UserDtoExtended,
  UserListDto,
  UserStatusEnum
} from "@esa/api";

export const getUsers = createAction(
  '[Users] Get Users',
  props<{ pageNumber: number, pageSize: number, userStatus: UserStatusEnum}>()
)

export const getUsersSuccess = createAction(
  '[Users] Get Users Success',
  props<{ users: UserDto[], totalUsers: number }>()
)

export const getUsersError = createAction(
  '[Users] Get Users Error',
)

export const createUser = createAction(
  '[Users] Create User',
  props<{ user: CreateUserCommand }>()
)

export const createUserSuccess = createAction(
  '[Users] Create User Success',
)

export const createUserError = createAction(
  '[Users] Create User Error',
)

export const getLoggedInUser = createAction(
  '[Users] Get Logged In User',
)

export const getLoggedInUserSuccess = createAction(
  '[Users] Get Logged In User Success',
  props<{ loggedInUser: UserDtoExtended }>()
)
export const getLoggedInUserError = createAction(
  '[Users] Get Logged In User Error',
)

export const getUserList = createAction(
  '[Users] Get User List',
  props<{ fiuId: string, userStatus?: UserStatusEnum }>()
)

export const getUserListSuccess = createAction(
  '[Users] Get User List Success',
  props<{ userList: UserListDto[] }>()
)
export const getUserListError = createAction(
  '[Users] Get User List Error',
)

export const getUserById = createAction(
  '[Users] Get User By ID',
  props<{ id: string }>()
)

export const getUserByIdSuccess = createAction(
  '[Users] Get User By ID Success',
  props<{ selectedUser: UserDto }>()
)

export const getUserByIdError = createAction(
  '[Users] Get User By ID Error',
)

export const setSelectedUserId = createAction(
  '[Users] Set Selected User Id',
  props<{ selectedUserId: string }>()
)

export const updateUser = createAction(
  '[Users] Update User',
  props<{ user: UpdateUserCommand }>()
)

export const updateUserSuccess = createAction(
  '[Users] Update User Success',
)

export const updateUserError = createAction(
  '[Users] Update User Error',
)

export const deleteUser = createAction(
  '[Users] Delete User',
  props<{ user: UpdateUserCommand, pageNumber: number, pageSize: number }>()
)

export const deleteUserSuccess = createAction(
  '[Users] Delete User Success',
  props<{pageNumber: number, pageSize: number}>()
)

export const deleteUserError = createAction(
  '[Users] Delete User Error',
)

export const reactivateUser = createAction(
  '[Users] Re-activate User',
  props<{ user: UpdateUserCommand, pageNumber: number, pageSize: number }>()
)

export const reactivateUserSuccess = createAction(
  '[Users] Re-activate User Success',
  props<{pageNumber: number, pageSize: number}>()
)

export const reactivateUserError = createAction(
  '[Users] Reactivate User Error',
)
export const setUserDisabled = createAction(
  '[Users] Set User Disabled',
  props<{ userDisabled: boolean }>()
);

export const resendUserInvitation= createAction(
  '[Users] Resend User Invitation',
  props<{ user: InviteUserCommand }>()
)

export const resendUserInvitationSuccess = createAction(
  '[Users] Resend User Invitation Success',
)

export const resendUserInvitationError = createAction(
  '[Users] Resend User Invitation Error',
)

